import { render, staticRenderFns } from "./facturaReal.vue?vue&type=template&id=23d74997&lang=html"
import script from "./facturaReal.vue?vue&type=script&lang=js"
export * from "./facturaReal.vue?vue&type=script&lang=js"
import style0 from "./facturaReal.vue?vue&type=style&index=0&id=23d74997&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports